var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor",
    style: {
      color: "#fff"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.339.348c.452.05.876.255 1.198.582l2.528 2.528.134.145c.294.35.46.793.466 1.254v6.81a1.998 1.998 0 0 1-1.998 1.998H2.333a1.998 1.998 0 0 1-1.998-1.998V2.333A1.999 1.999 0 0 1 2.333.335h6.81l.196.013ZM2.333 1.665a.669.669 0 0 0-.668.668v9.334a.669.669 0 0 0 .668.668h.669V8.333a1.332 1.332 0 0 1 1.331-1.331h5.334a1.332 1.332 0 0 1 1.331 1.331v4.002h.669a.669.669 0 0 0 .668-.668V4.876l-.015-.13a.669.669 0 0 0-.101-.237l-.084-.1-2.543-2.544a.669.669 0 0 0-.338-.185l-.13-.015H4.332v2.003H9a.665.665 0 0 1 0 1.33H4.333a1.332 1.332 0 0 1-1.331-1.331V1.665h-.669Zm1.999 10.67h5.336V8.332H4.332v4.003Z"
  })));
};
export default SvgSave;